<template>
  <div>
    <!--Dynamic Dial Second Step-->
    <div class="form-group m-b-15" v-if="enableDynamicDial">
      <label class="control-label col-md-3 col-sm-3">
        {{ $t('PING_TREE_TARGET_DYNAMIC_NUMBER_PARSING') }}
        <i
          v-tooltip.right="$t('PING_TREE_TARGET_DYNAMIC_NUMBER_PARSING_TT')"
          class="fa fa-question-circle m-l-5"
        />
      </label>
        <div class="display-flex m-b-10 col-md-9">
          <SearchableDropdown
            v-model="dynamicNumberParsing[0].property"
            class="m-r-15 m-b-10 input--size-md"
            :config="selectablePropertiesConfig"
            :clearable="false"
            rules="required"
            required
            @change="updateDynamicNumberParsingSettings"
          />
          <label 
                v-t="'REQUIRED'"
                class="form-group__label-required"
              />
        </div>
    </div>
  </div>
</template>
<script>
import messages from '../locales';
import sharedMessages from '@/core/locales';
import SearchableDropdown from '@/core/components/SearchableDropdown/SearchableDropdown';

export default {
  name: 'ConfirmationRequestParsingSettings',
  components: {
    SearchableDropdown
  }, 
  props: {
    dynamicNumberParsing: {
      type: Array,
      default() {
        return [];
      },
    },
    selectablePropertiesConfig: {
      type: Object,
      default() {
        return {};
      },
    },
    enableDynamicDial: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    updateDynamicNumberParsingSettings() {
      this.$emit('updateDynamicNumberParsingSettings');
    },
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  } 
};
</script>